var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[_c('div',{staticClass:"home__header"},[_c('header'),_c('div',{staticClass:"clear"})])])
}]

export { render, staticRenderFns }